/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ClientTotalUsersStatQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type ClientTotalUsersStatQuery = { __typename: 'Query', client?: { __typename: 'ClientType', id: string, employees?: { __typename: 'ClientEmployeeTypeConnection', totalCount?: number | null } | null } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const ClientTotalUsersStatDocument = new TypedDocumentString(`
    query ClientTotalUsersStat($clientId: UUID!) {
  client(id: $clientId) {
    id
    employees {
      totalCount
    }
  }
}
    `);

export const useClientTotalUsersStatQuery = <
      TData = ClientTotalUsersStatQuery,
      TError = unknown
    >(
      variables: ClientTotalUsersStatQueryVariables,
      options?: Omit<UseQueryOptions<ClientTotalUsersStatQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientTotalUsersStatQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientTotalUsersStatQuery, TError, TData>(
      {
    queryKey: ['ClientTotalUsersStat', variables],
    queryFn: fetcher<ClientTotalUsersStatQuery, ClientTotalUsersStatQueryVariables>(ClientTotalUsersStatDocument, variables),
    ...options
  }
    )};

useClientTotalUsersStatQuery.getKey = (variables: ClientTotalUsersStatQueryVariables) => ['ClientTotalUsersStat', variables];

export const useInfiniteClientTotalUsersStatQuery = <
      TData = InfiniteData<ClientTotalUsersStatQuery>,
      TError = unknown
    >(
      variables: ClientTotalUsersStatQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientTotalUsersStatQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientTotalUsersStatQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientTotalUsersStatQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ClientTotalUsersStat.infinite', variables],
      queryFn: (metaData) => fetcher<ClientTotalUsersStatQuery, ClientTotalUsersStatQueryVariables>(ClientTotalUsersStatDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientTotalUsersStatQuery.getKey = (variables: ClientTotalUsersStatQueryVariables) => ['ClientTotalUsersStat.infinite', variables];


useClientTotalUsersStatQuery.fetcher = (variables: ClientTotalUsersStatQueryVariables) => fetcher<ClientTotalUsersStatQuery, ClientTotalUsersStatQueryVariables>(ClientTotalUsersStatDocument, variables);
